import { render, staticRenderFns } from "./product-details.vue?vue&type=template&id=242eaf73&scoped=true&"
import script from "./product-details.vue?vue&type=script&lang=js&"
export * from "./product-details.vue?vue&type=script&lang=js&"
import style0 from "./product-details.vue?vue&type=style&index=0&id=242eaf73&prod&lang=scss&"
import style1 from "./product-details.vue?vue&type=style&index=1&id=242eaf73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242eaf73",
  null
  
)

export default component.exports